var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"dropper",style:(_vm.style),attrs:{"width":"200","height":"8"}},[_c('circle',{attrs:{"cx":"4","cy":"4","r":"4","fill":"firebrick"}}),_c('rect',{attrs:{"x":"4","y":"3","width":"200","height":"2","fill":"firebrick"}})])}
var staticRenderFns = []

export { render, staticRenderFns }